export default __webpack_public_path__ + "static/media/rote_forella_playeronly.a2741c99.png";